import React, { useState, useCallback } from 'react';
import { DialogProps } from '@radix-ui/react-dialog';

import { Sheet, SheetContent } from '@epoch-ui/components/Sheet/sheet';
import { Question, QUESTION_TYPE } from 'types/question.types';

import { FeedbackQuestionTypeSelector } from './FeedbackQuestionTypeSelector';
import { FeedbackQuestionEditor } from './FeedbackQuestionEditor';

interface EditFeedbackQuestionSideSheetProps extends DialogProps {
  question?: Question;
  onWarningResendFeedback: () => void;
}

export const EditFeedbackQuestionSideSheet: React.FC<EditFeedbackQuestionSideSheetProps> = ({
  question,
  onWarningResendFeedback,
  onOpenChange,
  ...props
}) => {
  const [selectedType, setSelectedType] = useState<QUESTION_TYPE | null>(null);

  const handleCloseSheet = useCallback(
    (open: boolean): void => {
      onOpenChange?.(open);
      if (!open) {
        setTimeout(() => {
          setSelectedType(null);
        }, 300);
      }
    },
    [onOpenChange]
  );

  return (
    <Sheet onOpenChange={handleCloseSheet} {...props}>
      <SheetContent className="tw-m-2 tw-flex tw-h-[98.2%] tw-w-[480px] tw-max-w-[480px] tw-flex-col tw-rounded-lg tw-pb-4 sm:tw-max-w-[75%] md:tw-max-w-[40%] xl:tw-max-w-[36%]">
        {selectedType === null && !question ? (
          <FeedbackQuestionTypeSelector onSelect={(type) => setSelectedType(type)} />
        ) : (
          <FeedbackQuestionEditor
            type={question?.type ?? selectedType!}
            onBack={() => setSelectedType(null)}
            handleClose={() => handleCloseSheet(false)}
            question={question}
            onWarningResendFeedback={onWarningResendFeedback}
          />
        )}
      </SheetContent>
    </Sheet>
  );
};
